<div class="wrapper position-rel" (click)="emitField()" (mouseover)="showIconUp=true" (mouseout)="showIconUp=false">
 <div class="centered-row-container row-gap-0p3125">
  <span class="title  {{count > -1 ? 'company-name' : ''}}"
    [innerHTML]="title">
  </span>
  <div class="vertical-container-simple">
    <img *ngIf="count < 0 && !showIconUp" class="height-1" src="/assets/svg/common/arrow-neutral.svg">
    <img *ngIf="count === 0 || showIconUp" class="height-1" src="/assets/svg/common/sort-up.svg">
    <img *ngIf="count > 0 && !showIconUp" class="height-1" src="/assets/svg/common/sort-down.svg">
  </div>
</div>
<div class="flex-grow-1">

</div>
  <div>
    <app-search-icon
    *ngIf="showSearchIcon && (!showFilterDropDown || !showCheckboxSelector)"
    [attr.data-qa]="searchIconDataQa"
    class="icon-background-hover clickable"
    (click)="$event.stopPropagation(); emitSearch()"
  >
  </app-search-icon>
  </div>
  <app-checkbox-selector
    *ngIf="showCheckboxSelector"
    class="min-width-9"
    [items]="checkBoxItems">
  </app-checkbox-selector>
  <app-filter-dropdown
    *ngIf="showFilterDropDown"
    class="min-width-12"
    (cancel)="close()"
    (onchange)="emitChanges($event)">
  </app-filter-dropdown>
</div>
